import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  NavigationConfiguration,
  NavigationStateData,
} from '@zipari/shared-ds-util-navigation';

@Component({
  selector: 'nav-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
})
export class ButtonsComponent {
  @Input() config: NavigationConfiguration;
  @Input() data: NavigationStateData;

  @Output() contactUsButtonClicked = new EventEmitter<void>();
  @Output() loginClicked = new EventEmitter<void>();
  @Output() logoutClicked = new EventEmitter<void>();

  toggleContactUs(): void {
    this.contactUsButtonClicked.emit();
  }

  login(): void {
    this.loginClicked.emit();
  }

  logout(): void {
    this.logoutClicked.emit();
  }
}
